import { dangerouslyInjectHTML } from '@visiba/react-std';
import { HeadlessIcon, HeadlessIconProps } from '../icon';
import loadedIllustrationSet from './illustration_set.json';

interface IllustrationDictionary {
	fileExcel: string;
	filePdf: string;
	fileVideo: string;
	fileWord: string;
	fileImage: string;
	fileOtherFormat: string;
	attachedForm: string;
}

type IllustrationMap = {
	[key in keyof IllustrationDictionary]: {
		innerHTML: string;
		viewBox: string;
	};
};

type IllustrationType = keyof IllustrationDictionary;

const illustrationMap = loadedIllustrationSet as unknown as IllustrationMap;

interface IllustrationProps extends Omit<HeadlessIconProps, 'viewBox'> {
	/**
	 * The icon to use.
	 */
	type: IllustrationType;
}

export function Illustration({ type, ...rest }: IllustrationProps): JSX.Element {
	return (
		<HeadlessIcon
			viewBox={illustrationMap[type]?.viewBox}
			dangerouslySetInnerHTML={dangerouslyInjectHTML(illustrationMap[type]?.innerHTML)}
			{...rest}
		/>
	);
}
